import { Action, Dispatch } from 'redux'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'
import { confirmStoreDeliveryBreadAction } from 'reducks/storeDeliveryBread/actions'

const confirmStoreDeliveryBread = (storeDeliveryBread: StoreDeliveryBreadType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmStoreDeliveryBreadAction(storeDeliveryBread))
  }
}

export default confirmStoreDeliveryBread
